import React, {useEffect, useState} from "react";
import SpinnerLoader from "@common/components/spinner-loader";

interface QrCodeProps {
    src: string;
    size?: number;
    className?: string;
}

const QrCode: React.FC<QrCodeProps> = ({src, size = 256, className}) => {
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [isError, setIsError] = useState<boolean>(false);

    useEffect(() => {
        setIsLoading(true);
        setIsError(false);
    }, [src]);

    return (
        <div className={className} style={{width: size + 16, height: size + 16}}>
            <img
                src={src}
                alt="Kod QR"
                width={size}
                height={size}
                className="block"
                style={{display: isLoading ? 'none' : 'block'}}
                onLoad={() => setIsLoading(false)}
                onError={() => {
                    setIsLoading(false);
                    setIsError(true);
                }}
            />
            {isLoading && (
                <div className="relative w-full h-full flex items-center justify-center bg-white">
                    <div className="absolute top-3 left-3 flex items-center justify-center w-12 h-12 bg-black">
                        <div className="w-9 h-9 border-[8px] border-white relative"/>
                    </div>
                    <div
                        className="absolute top-3 right-3 flex items-center justify-center w-12 h-12 bg-black">
                        <div className="w-9 h-9 border-[8px] border-white relative"/>

                    </div>
                    <div
                        className="absolute bottom-3 left-3 flex items-center justify-center w-12 h-12 bg-black">
                        <div className="w-9 h-9 border-[8px] border-white relative"/>
                    </div>
                    <SpinnerLoader size="28" />
                </div>
            )}
            {isError && !isLoading && (
                <div className="w-full h-full flex items-center justify-center text-sm text-on-surface/70">
                    Nie udało się wczytać kodu QR
                </div>
            )}
        </div>
    );
}

export default QrCode;
